<template>

  <div class="pure-g">
    <div class="pure-u-md-1-5 pure-u-lg-1-4"></div>
    <div class="pure-u-1 pure-u-md-3-5 pure-u-lg-1-2">
      <div class="content box padding-30-reactive">
        <div class="pure-g">

          <div class="spacing-30 pure-u-1"></div>

          <div class="pure-u-sm-1-5 pure-u-lg-1-4"></div>

          <div class="pure-u-1 pure-u-sm-3-5 pure-u-lg-1-2">
            <h3 class="margin-bottom-10 responsive"> Login to your Tavour account! </h3>
            <div class="subtext margin-left-10">
              New to Tavour? <a class="link" @click="$emit('register')">create a new account</a>
            </div>
            <div class="spacing-20" v-if="showSso"></div>
            <SsoButtons v-if="showSso"/>
            <form class="pure-u-1 pure-form pure-form-stacked" @submit.prevent="submit">
              <div class="spacing-20"></div>
              <input class="pure-input-1" id="email" type="email" placeholder="email" v-model="email">

              <input class="pure-input-1" type="password" placeholder="password" v-model="password">
              <button class="pure-button pure-button-primary block" type="submit" :disabled="disabled">Login</button>
              <p class="text-red" v-if="error">
                {{error}}
              </p>
            </form>
          </div>

          <div class="spacing-30 pure-u-1"></div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import session from '../../lib/session';
  import store from '../../lib/store';
  import * as sso from '../../lib/sso';
  import SsoButtons from '../account/SsoButtons';

  export default {
    name: 'Login',
    components: {
      SsoButtons,
    },
    // `sso` is set by the Direct flow only; the older flows keep email login.
    props: ['sso'],
    data() {
      return {
        isBusy: false,
        error: false,
        email: '',
        password: '',
      };
    },
    created() {
      /* global ga */
      ga('send', 'pageview', `/${store.get('subscription')}/Login`);
    },
    methods: {
      submit() {
        this.error = '';
        this.isBusy = true;
        session.create(this.email, this.password, (err, res) => {
          this.isBusy = false;
          if (err) {
            if (res && res.statusCode === 422) {
              this.error = 'That email and password do not match.';
              if (this.showSso) this.error += ` ${sso.SSO_HINT}`;
            } else {
              this.error = 'Something went wrong, please try again.';
            }
          } else if (res.body.session.user_in_service_area) {
            sso.clearSession();
            store.set('authToken', res.body.session.user_token);
            this.$emit('success');
          } else {
            this.error = 'Sorry, we don\'t currently deliver to your area.';
          }
        });
      },
    },
    computed: {
      showSso() {
        return Boolean(this.sso) && sso.isEnabled();
      },
      disabled() {
        return this.isBusy || this.email === '' || this.password === '';
      },
    },
  };
</script>



// WEBPACK FOOTER //
// Login.vue?99503572